// todo: 將 itinerary 有用到的 action type 慢慢遷移過來

export const ADD_PRODUCT_TO_TRIP = {
  INIT: 'addProductToTripInit',
  LOADING: 'addProductToTripLoading',
  SUCCESS: 'addProductToTripSuccess',
  FAIL: 'addProductToTripFail',
};

export const GET_RECOMMEND_TRIPS = {
  LOADING: 'getRecommendTripsLoading',
  SUCCESS: 'getRecommendTripsSuccess',
  FAIL: 'getRecommendTripsFail',
};

export const GET_TRIP_LIST = {
  INIT: 'getTripListInit',
  LOADING: 'getTripListLoading',
  SUCCESS: 'getTripListSuccess',
  FAIL: 'getTripListFail',
};
